import * as React from "react";
import { CallbackParams, FormModel } from "./types";
import { TronPaymentButton } from "./TronPaymentButton";
import { ThirdwebPayButton } from "./ThirdwebPayButton";
import { ShortUrl } from "./ShortUrl";
import { SolanaPay } from "./SolanaPay";
import { LiberlandPay } from "./LiberlandPay";

export interface GatewayCreatorProps {
    formModel: FormModel,
    setTransactionId: (txId: string) => void,
}

export const GatewayCreator: React.FunctionComponent<GatewayCreatorProps> = (props) => {
    const processingParams: CallbackParams = {
        formModel: props.formModel,
        step: 2,
    };
    const redirectUrl = new URL(`${window.location.protocol}//${window.location.host}`);
    redirectUrl.searchParams.append("encoded", window.btoa(JSON.stringify(processingParams)));

    switch (props.formModel.fromChain) {
        case "Ethereum":
            return !props.formModel.transactionHash ? (
                <>
                    <ThirdwebPayButton
                        formModel={props.formModel}
                        setTransactionId={props.setTransactionId}
                    />
                    <ShortUrl url={redirectUrl.toString()} type="Ethereum" />
                </>
            ) : null;
        case "Liberland":
            return (
                <>
                    <LiberlandPay formModel={props.formModel} />
                    <ShortUrl url={redirectUrl.toString()} type="Liberland" />
                </>
            );
        case "Solana":
            return !props.formModel.transactionHash ? (
                <>
                    <SolanaPay formModel={props.formModel} setTransactionId={props.setTransactionId} />
                    <ShortUrl url={redirectUrl.toString()} type="Solana" />
                </>
            ) : null;
        case "Tron":
            return !props.formModel.transactionHash ? (
                <>
                    <TronPaymentButton formModel={props.formModel} setTransactionId={props.setTransactionId} />
                    <ShortUrl url={redirectUrl.toString()} type="Tron" />
                </>
            ) : null;
    }
};
